import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import HtmlTooltip from "@/src/mui-custom/html-tooltip/html-tooltip";
import React from "react";
import Image from "next/image";
import CoverOverview from "@/src/_types/cover-overview";
import CoverImageBox
    from "@/src/components/journal-site/common/journal-cover-image/mui-custom/cover-image-box/cover-image-box";
import TooltipBox from "@/src/mui-custom/html-tooltip/mui-custom/tooltip-box/tooltip-box";

const JournalCoverImage: React.FC<CoverOverview> = ({journalName, image, icon, width, height}) => {
    return (
        <HtmlTooltip title={
            <TooltipBox>
                <FontAwesomeIcon icon={icon} className={`icon`}/>
                <b>{journalName}</b>
            </TooltipBox>
        }>

            {image ? (
                    <CoverImageBox
                        sx={{
                            width: width ?? '100%',
                            height: height ?? '100%',
                        }}>
                        <Image
                            src={image}
                            width={width ?? 192}
                            height={height ?? 292}
                            alt={journalName}
                            style={{
                                position: 'relative',
                                width: '100%',
                                height: '100%'
                            }}
                        />
                    </CoverImageBox>
                ) :
                (
                    <FontAwesomeIcon
                        style={{
                            fontSize: '5em',
                            maxWidth: '8rem',
                            textAlign: 'center',
                            marginTop: '1.5rem',
                            paddingRight: '1.5rem'
                        }}
                        icon={icon}
                    />
                )
            }
        </HtmlTooltip>
    );
};

export default JournalCoverImage;
